import { actionTypes, mutationTypes } from '@/core/constants'
import api from '@/core/apiclient/adesao/revisoes/RevisoesAdesaoApiClient'

export default {
	async [actionTypes.ADESAO.REVISOES.BUSCAR_DISPONIVEL]({ commit }, idAdesao) {
		const { data } = await api.buscarRevisoesDisponivel(idAdesao)
		commit(mutationTypes.ADESAO.SET_REVISAO, data)
		return data
	},

	async [actionTypes.ADESAO.REVISOES.CRIAR](context, { idAdesao, revisao }) {
		await api.criarRevisaoAdesao(idAdesao, revisao)
	},
}
